<template>
  <v-main class="app">
    <div class="headers">
      <div class="header-wrapper">
        <div class="main-header" v-if="!$vuetify.display.mobile">
          {{ $route.params.type == 'own' ? $t('donor.phenotype.complete_header_own') : $t('donor.phenotype.complete_header_partner') }}<br>
        </div>
        <div class="main-header mobile mt-16" v-else>
          {{ $route.params.type == 'own' ? $t('donor.phenotype.complete_header_own') : $t('donor.phenotype.complete_header_partner') }}<br>
        </div>
      </div>
      <div class="header-wrapper">
        <div class="sub-header" v-if="!$vuetify.display.mobile">
          {{ $route.params.type == 'own' ? $t('donor.phenotype.complete_subheader_own') : $t('donor.phenotype.complete_subheader_partner') }}<br>
        </div>
        <div class="sub-header mobile" v-else>
          {{ $route.params.type == 'own' ? $t('donor.phenotype.complete_subheader_own') : $t('donor.phenotype.complete_subheader_partner') }}<br>
        </div>
      </div>
    </div>
    <div class="search-wrapper mb-16">
      <recipient-phenotype-component :type="'complete'" ref="recipientPhenotypeComponent"/>
    </div>
  </v-main>
</template>

<script>
import RecipientPhenotypeComponent from '../components/RecipientPhenotypeComponent.vue';

export default {
  data() {
    return {
      type: this.$route.params.type
    }
  },
  components: {
    RecipientPhenotypeComponent
  },
  mounted() {
    this.$store.dispatch('phenotypeModule/setCurrentPhenotype', this.type);
    //TODO: Set proper breadcrumbs route
    this.$store.dispatch('breadcrumbModule/setRoute', [{
      name: 'breadcrumb.want_to_be_a_parent',
      url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
      absolute: true
    },{
      name: 'breadcrumb.search',
      url: ''
    },])
    this.$store.dispatch('resultsModule/setSearchForSimilar', false);
  }
}
</script>


<style lang="scss" scoped>
  .app {
    position: relative;
    background: transparent;
    .search-wrapper {
      position: relative;
      z-index: 10 !important;
      max-width: 792px;
      margin: 0 auto;
    }
    .headers {
      position: relative;
      z-index: 2;
      padding-bottom: 10px;
      overflow: hidden;
    }
  }
  .main-header {
    background: transparent;
    text-align: left;
    @include nsb-font-main-header;
    font-size: 18px;
    line-height: 27px;
    margin-left: 16px;
    margin-top: 24px;
    &-bold {
      background: url('../assets/svg/squiggle.svg');
      background-position: center bottom;
      background-repeat: no-repeat;
      padding-right: 5px;
    }
    &.mobile {
      font-size: 24px;
    }
  }

  .sub-header {
    position: relative;
    width: 996px;
    margin-top: 16px;
    margin-bottom: 32px;
    text-align: left;
    @include nsb-font-header;
    font-size: 10px;
    line-height: 21px;
    position: relative;
    margin-left: 16px;
    &-bold {
      @include nsb-font-header-bold;
      font-size: 10px;
      position: relative;
      &.mobile {
        font-size: 14px;
        line-height: 24px;
      }
    }
    &.mobile {
      font-size: 14px;
        line-height: 24px;
      width: calc(100% - 48px);
    }
  }
  // i leave it here in case someone want
  // that abomination to be visible on
  // mobile browsers
  .header-image {
    z-index: 1;
    width: 170vw;
    position: absolute;
    top: 0px;
    transform: translateX(-50%);
  }

  @media (min-width: 996px) {
    .header-wrapper {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      // width: 100vw;

      &.mobile {
        font-size: 14px;
      }
    }
    .headers {
      padding-bottom: 32px !important;
      overflow: hidden;
      max-width: 726px;
      margin: 0 auto;
    }
    .header-image {
      z-index: 1;
      width: 100vw;
      position: absolute;
      top: 0px;
      transform: translateX(-50%);
    }
    .main-header {
      line-height: 46px;
      width: 996px !important;
      margin-top: 40px;
      margin-left: 0;
      font-size: 40px;
      &-bold {
        font-size: 40px;
      }
    }
    .sub-header {
      width: 996px !important;
      margin-top: 16px;
      margin-left: 0px;
      font-size: 14px;
      line-height: 21px;
      margin-bottom: 0;
      &-bold {
        font-size: 14px;
      }
    }
  }
</style>